import { createApp } from 'vue'
//import { useRoute } from 'vue-router'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import PrimeVue from "primevue/config";
import primeConfig from './primeConfig'
import VueSweetalert2 from 'vue-sweetalert2';
import VSwatches from 'vue3-swatches';
import 'vue3-swatches/dist/style.css'
const primeOption = primeConfig
//const route = useRoute()
//console.log(route)

import jQuery from 'jquery'
/* ADD STORE IN PROJECT USING VUEX */
import store from "@/store/store";


const path = window.location.pathname;
console.log(path);

// Check for URL parameters with tokens on app initialization
function checkURLParamsOnLoad() {
  const params = new URLSearchParams(window.location.search);
  
  // Check for SSO callback parameters first
  const ssoSuccess = params.get('success');
  const accessToken = params.get('access_token') || params.get('access');
  const refreshToken = params.get('refresh_token') || params.get('refresh');
  const userParam = params.get('user');
  const email = params.get('email');
  const name = params.get('name');
  const created = params.get('created'); // Check if this is a new user
  const errorParam = params.get('error');
  
  // Check for regular authentication parameters
  const user = params.get('user');
  const firstname = params.get('firstname');
  const lastname = params.get('lastname');
  const organisation = params.get('organisation');
  const typeAccount = params.get('type_account');
  const role = params.get('role');
  
  // Handle SSO activation page - when user is redirected directly to /sso/account
  // DO NOT save tokens here - they will be saved only after successful form submission
  if (window.location.pathname === '/sso/account') {
    const emailParam = params.get('email');
    if (emailParam) {
      console.log('SSO activation page accessed with email:', emailParam);
      // Only save email for reference, but NOT tokens - tokens will be saved after form submission
      localStorage.setItem('sso_email', emailParam);
      
      // Save name for reference if available
      if (name) localStorage.setItem('sso_name', name);
      
      // DO NOT save tokens here - they will be saved in SSOActivate.vue after successful form submission
      return; // Let the page load normally
    }
  }
  
  // Handle SSO callback parameters
  if (ssoSuccess === 'true' && accessToken && refreshToken) {
    console.log('SSO callback parameters detected...');
    console.log('Created parameter:', created);
    console.log('Current path:', window.location.pathname);
    
    // Check if there's an error
    if (errorParam) {
      console.error('SSO callback error:', errorParam);
      alert('SSO Error: ' + decodeURIComponent(errorParam));
      return;
    }
    
    // Parse user data to check if user is new or existing
    let isNewUser = false;
    let userData = null;
    
    if (userParam) {
      try {
        const decodedUser = decodeURIComponent(userParam);
        console.log('Decoded user param:', decodedUser);
        
        // Parse the user data - handle Python dict format
        try {
          // First try to parse as JSON (replace single quotes with double quotes)
          userData = JSON.parse(decodedUser.replace(/'/g, '"'));
        } catch (jsonError) {
          // If JSON parsing fails, try to extract values manually
          console.log('JSON parsing failed, trying manual extraction...');
          userData = {};
          
          // Extract UUID values
          const idMatch = decodedUser.match(/UUID\(['"]([^'"]+)['"]\)/);
          if (idMatch) userData.id = idMatch[1];
          
          // Extract string values
          const firstnameMatch = decodedUser.match(/['"]firstname['"]:\s*['"]([^'"]+)['"]/);
          if (firstnameMatch) userData.firstname = firstnameMatch[1];
          
          const lastnameMatch = decodedUser.match(/['"]lastname['"]:\s*['"]([^'"]+)['"]/);
          if (lastnameMatch) userData.lastname = lastnameMatch[1];
          
          const typeAccountMatch = decodedUser.match(/['"]type_account['"]:\s*['"]([^'"]+)['"]/);
          if (typeAccountMatch) userData.type_account = typeAccountMatch[1];
          
          const roleMatch = decodedUser.match(/['"]role['"]:\s*['"]([^'"]+)['"]/);
          if (roleMatch) userData.role = roleMatch[1];
          
          const serviceMatch = decodedUser.match(/['"]service['"]:\s*['"]([^'"]+)['"]/);
          if (serviceMatch) userData.service = serviceMatch[1];
          
          const orgMatch = decodedUser.match(/['"]organisation['"]:\s*UUID\(['"]([^'"]+)['"]\)/);
          if (orgMatch) userData.organisation = orgMatch[1];
          
          const codeOrgMatch = decodedUser.match(/['"]code_organisation['"]:\s*['"]([^'"]+)['"]/);
          if (codeOrgMatch) userData.code_organisation = codeOrgMatch[1];
          
          const isCompletedMatch = decodedUser.match(/['"]is_completed['"]:\s*(True|False)/);
          if (isCompletedMatch) userData.is_completed = isCompletedMatch[1] === 'True';
        }
        
        console.log('Parsed user data:', userData);
        
        // Determine if user is new based on created parameter or is_completed flag
        isNewUser = created === 'true' || userData.is_completed === false || userData.is_completed === 'False';
        
      } catch (error) {
        console.warn('Could not parse SSO user data:', error);
        // If we can't parse user data, check created parameter
        isNewUser = created === 'true';
      }
    } else {
      // If no user param, check created parameter
      isNewUser = created === 'true';
    }
    
    // Store tokens
    localStorage.setItem('token', accessToken);
    localStorage.setItem('refresh_token', refreshToken);
    
    // Handle user data from SSO
    if (userData) {
      // Store user information
      if (userData.id) localStorage.setItem('user', userData.id);
      if (userData.firstname) localStorage.setItem('firstname', userData.firstname);
      if (userData.lastname) localStorage.setItem('lastname', userData.lastname);
      if (userData.type_account) localStorage.setItem('type_account', userData.type_account);
      if (userData.role) localStorage.setItem('role', userData.role);
      if (userData.organisation) localStorage.setItem('organisation', userData.organisation);
      if (userData.code_organisation) localStorage.setItem('code_organisation', userData.code_organisation);
      if (userData.service) localStorage.setItem('service', userData.service);
      if (userData.is_completed !== undefined) localStorage.setItem('is_completed', userData.is_completed);
    } else if (email) {
      localStorage.setItem('email', decodeURIComponent(email));
      if (name) localStorage.setItem('firstname', decodeURIComponent(name));
    }
    
    // Clear URL parameters
    const newUrl = window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);
    
    console.log('SSO authentication setup complete from URL parameters');
    console.log('Is new user:', isNewUser);
    
    // Redirect based on whether user is new or existing
    if (isNewUser) {
      // New user - redirect to activation page
      console.log('New SSO user detected, redirecting to activation page...');
      // Store email and name for activation form
      if (email) localStorage.setItem('sso_email', email);
      if (name) localStorage.setItem('sso_name', name);
      setTimeout(() => {
        window.location.href = '/sso/account';
      }, 100);
    } else {
      // Existing user - redirect to dashboard
      console.log('Existing SSO user detected, redirecting to dashboard...');
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 100);
    }
    
    return;
  }
  
  // Handle regular authentication parameters
  if (accessToken && refreshToken && user && firstname && lastname && organisation && typeAccount && role) {
    console.log('Regular authentication parameters detected, setting up authentication...');
    localStorage.setItem('token', accessToken);
    localStorage.setItem('refresh_token', refreshToken);
    localStorage.setItem('user', user);
    localStorage.setItem('firstname', firstname);
    localStorage.setItem('lastname', lastname);
    localStorage.setItem('organisation', organisation);
    localStorage.setItem('type_account', typeAccount);
    localStorage.setItem('role', role);
    const newUrl = window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);
    console.log('Regular authentication setup complete from URL parameters');
  }
}

// Run the check immediately
checkURLParamsOnLoad();

/* BOOSTRAP AND CSS UTILS */

/* MULTILANGUAGE APP CONFIG */
import { createI18n } from 'vue-i18n'
import messages from './lang'
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';
export const i18n = createI18n({
    locale: localStorage.getItem('language') || 'fr',
    fallbackLocale: 'fr',
    messages,
    legacy: false,
})

/* CALENDAR COMPOENETS */
// import Calendar from '@pigsking/vue-mark-calendar'

const app = createApp(App)
app.use(ToastService).use(ConfirmationService)
app.directive('tooltip', Tooltip);
//import 'bootstrap'
window.$ = window.jQuery = jQuery;
if (!path.match(/^\/audits/) && !path.match(/^\/modules-courses/) && !path.match(/^\/user-manage/) && !path.match(/^\/user-follow/) && !path.match(/^\/microlearning-campaign/) && !path.match(/^\/statistics/)) {
    /* JQUERY SETUP IN VUE APP */
    // Add link tag for daisyUI
    //const daisyUiLink = document.createElement('link');
    //daisyUiLink.rel = 'stylesheet';
    //daisyUiLink.type = 'text/css';
    //daisyUiLink.href = 'https://cdn.jsdelivr.net/npm/daisyui@4.12.24/dist/full.min.css';
    //document.head.appendChild(daisyUiLink);
    // Add script tag for Tailwind CSS
    //const tailwindScript = document.createElement('script');
    //tailwindScript.src = 'https://cdn.jsdelivr.net/npm/@tailwindcss/browser@4';
    //document.head.appendChild(tailwindScript);
    // Dynamic imports for plugins
    //const VueSweetalert2 = await import('vue-sweetalert2');
    const options = {
        confirmButtonColor: '#0abbc4',
        cancelButtonColor: '#272f43',
    };
    const VueSocialSharing = await import('vue-social-sharing');
    //const VSwatches = await import('vue3-swatches');
    await import ('popper.js')
    await import ('./assets/css/font-awesome.min.css')
    await import ('bootstrap/dist/css/bootstrap.min.css')
    await import ('bootstrap/dist/js/bootstrap.bundle.min.js')
    await import ('./assets/css/app.scss')
    await import ('./assets/css/style.css')
    await import ('./assets/scss/index.scss');
    await import ('sweetalert2/dist/sweetalert2.min.css');
    //await import ('vue3-swatches/dist/style.css')

    app.use(router).use(i18n).use(VueSocialSharing).use(VueSweetalert2, options).use(VSwatches).use(store).mount('#app')
} else {
    await import ('./assets/scss/app/styles.scss')
    //const ToastService = await import ('primevue/toastservice')
    //const ConfirmationService = await import ('primevue/confirmationservice')
    app.use(router).use(i18n).use(store).use(PrimeVue, primeOption).mount('#app')
}

const token = localStorage.getItem('token')
if (token) {
    axios.defaults.headers.common['Authorization'] = token
}
